import { generalLink } from '@pkg/sanity-utils/linkQueries';
import groq from 'groq';

export const blockButtonGroupFields = groq`
  ...,
  buttons[] {
    ...,
    link {
      ${generalLink}
    }
  }
`;
